import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ConversationService } from '../services/conversation.service';
import { WorkspaceService } from '../services/workspace.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';

@Component({
  selector: 'app-khamis',
  templateUrl: './khamis.component.html',
  styleUrls: ['./khamis.component.css']
})
export class KhamisComponent implements OnInit, OnDestroy {

  @ViewChild('text') public input:ElementRef;
  @ViewChild('autoComplete') autoCompleteRef: MatAutocomplete;
  @ViewChild('trigger', {read: MatAutocompleteTrigger}) matAutocomplete: MatAutocompleteTrigger;

  @Input() searchType: string;
  @Output() searchChanged = new EventEmitter<boolean>();
  @Output() searchResultId = new EventEmitter<string>();

  private hasUpdate:boolean = false;
  isBusy: boolean = false;
  isSearching: boolean = false;
  speechData:any;
  searchTextChanged = new Subject<string>();
  suggestions = [];
  subs: Subscription;
  
  constructor(private workspaceService:WorkspaceService, 
    private conversationService:ConversationService, private router:Router) {}

  ngOnInit() {
    // this.input.nativeElement.focus(); // autofocus
    this.getSuggestions();
  }

  ngOnDestroy() {
    if (this.subs) this.subs.unsubscribe();
  }

  searchGlobal(value:string){
    // this.workspaceService.searchEPICs(value).subscribe(result=>{
    //   this.searchResultId.emit(result);
    //   this.hasUpdate = !this.hasUpdate;
    //   this.searchChanged.emit(this.hasUpdate);
    // });
    this.isBusy = true;
    if (value){
      this.conversationService.converse(value).subscribe(result=> {
        var resultObject = JSON.parse(result);
        this.isBusy = false;
          if(resultObject.ReturnType == "0"){
            if(resultObject.Arguments){
              var path = [];
              resultObject.Arguments.forEach(element => {
                path.push(element);
              });;
              this.router.navigate(path);
            }
          }
      }, error => {
        this.isBusy = false;
      });
    }
    else {
      this.isBusy = false;
    }
  }

  onValueChange(keyword: string){
    this.searchTextChanged.next(keyword);
  }

  getSuggestions(){
    this.subs = this.searchTextChanged.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      ).subscribe(value => {
        this.isSearching = true;
        this.conversationService.getSuggestions(this.searchType, value).subscribe(result => {
          if (result){
            this.suggestions = JSON.parse(result);
          }
          this.isSearching = false;
        }, error => {
          this.isSearching = false;
        })
    })
  }

  mouseEnter(word: string){
    this.input.nativeElement.value = word;
  }

  mouseLeave(){
    this.input.nativeElement.value = "";
  }
}
